import { useEffect } from 'react';
import { useStorageWriteApprovalStore } from '../store/storageWriteApprovalStore';

export function useStorageWriteApprovalRequests(): void {
  const setPendingRequest = useStorageWriteApprovalStore((state) => state.setPendingRequest);
  const dismissRequest = useStorageWriteApprovalStore((state) => state.dismissRequest);

  useEffect(() => {
    const api = window.electronAPI?.mcpUiControl;
    // Review G F3: any approval event after the pull went out — a pushed request, a dismissal, a local answer, the
    // unmount — makes its answer stale (it may name a request that settled meanwhile), so it is dropped.
    let generation = 0;
    const invalidatePull = (): void => { generation += 1; };
    const unsubscribeRequest = api?.onStorageWriteApprovalRequest((request) => {
      invalidatePull();
      setPendingRequest(request);
    });
    // Review C C2: main dismissed the request (the MCP client cancelled it, or it timed out).
    const unsubscribeDismissed = api?.onStorageWriteApprovalDismissed?.(({ requestId }) => {
      invalidatePull();
      dismissRequest(requestId);
    });
    const unsubscribeStore = useStorageWriteApprovalStore.subscribe((state, previous) => {
      if (state.pendingRequest !== previous.pendingRequest) invalidatePull();
    });
    // Review F E2: after a reload main may have sent the approval on screen before these listeners existed (the
    // message is lost) — ask for it once BOTH are in place; an empty answer never closes one pushed meanwhile.
    const issued = generation;
    void api?.getPendingStorageWriteApproval?.().then((request) => {
      if (request && generation === issued) setPendingRequest(request);
    }).catch(() => undefined);
    return () => {
      invalidatePull();
      unsubscribeStore();
      unsubscribeDismissed?.();
      unsubscribeRequest?.();
    };
  }, [setPendingRequest, dismissRequest]);
}
